<section class="controls-container app-bg-secondary d-flex align-items-start justify-content-between px-2 pt-2">

  <div class="d-flex flex-row button-bar" style="justify-content: stretch;align-items: stretch">
    <ng-container *ngFor="let control of controls.status">
      <button *ngIf="control.title"
              class="btn app-btn-reverse-success rounded-pill border-white mx-1 mb-3"
              style="font-size:13px;font-weight:600;"
              (click)="control.onClick()"
              [disabled]="(waitOnAction || unsavedChanges || (actionNotAllowed(control) && !(bypassSignature && dealStatus === 'created'))) && !['Report Bug','Tax Lookup'].includes(control.title)">
        {{ control.title }}
      </button>
    </ng-container>
    <div *ngIf="dealStatus === 'created' && !bypassSignature" style="
    font-weight:500;font-size:14px;margin: 0 10px 7px 0 !important;display: flex;gap:5px;border-radius:14px;align-items: center;text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);;justify-content: center;padding:2px 14px 2px 9px;background: #8d8e00;color:#fff;">
     <mat-icon style="fill: white;width:16px;height:16px;font-size:16px">warning</mat-icon> <span>Customer signature needed to continue</span> <a href="#" style="color: white; text-decoration: underline; margin-left: 10px;" (click)="onBypassClick($event)">Bypass</a>
    </div>
  </div>

  <div class="button-bar">
    <button *ngFor="let control of controls.form"
            class="btn app-btn-reverse-success rounded-pill border-white mx-1 mb-3"
            style="margin:0 0 7px 15px!important;font-size:13px;font-weight:600;"
            (click)="control.onClick()"
            [disabled]="waitOnAction || !unsavedChanges">
      {{ control.title }}
    </button>
  </div>

</section>
